"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceForJobView = void 0;
const typeorm_1 = require("typeorm/browser");
const service_for_job_1 = require("./service-for-job");
const opportunity_1 = require("../opportunity");
const service_view_1 = require("../service-view");
const job_1 = require("../job");
const base_job_service_1 = require("../base-job-service");
const job_service_1 = require("../job-service");
const entity_1 = require("../../util/entity");
let ServiceForJobView = class ServiceForJobView extends service_for_job_1.ServiceForJob {
    static cmp(a, b) {
        var _a, _b;
        if (a.sortIndex === null)
            a.sortIndex = Number.MAX_SAFE_INTEGER;
        if (b.sortIndex === null)
            b.sortIndex = Number.MAX_SAFE_INTEGER;
        let order = a.sortIndex - b.sortIndex;
        if (order === 0) {
            order = ((_a = a.isPlanning) !== null && _a !== void 0 ? _a : true) - ((_b = b.isPlanning) !== null && _b !== void 0 ? _b : true);
        }
        if (order === 0) {
            order = a.createdDate.getTime() - b.createdDate.getTime();
        }
        return order;
    }
};
ServiceForJobView = __decorate([
    (0, typeorm_1.ViewEntity)({
        dependsOn: [service_view_1.ServiceView],
        expression: (connection) => {
            const baseJobServiceColumns = (0, entity_1.getEntityColumns)(base_job_service_1.BaseJobService, connection);
            const serviceColumns = (0, entity_1.getEntityColumns)(service_for_job_1.ServiceForJob, connection);
            let qb = connection
                .createQueryBuilder()
                .select('job.sfid', 'sfj_job_sfid')
                .addSelect('job_service.id', 'id')
                .addSelect('service.sfid', 'sfid')
                .addSelect('COALESCE(job_service.invoicing_target__c::text,opportunity.invoicing_target__c::text)', 'invoicing_target__c')
                .from(job_service_1.JobService, 'job_service')
                .innerJoin(job_1.Job, 'job', '(job_service.job_id = job.api_id__c)')
                .innerJoin(opportunity_1.Opportunity, 'opportunity', '(job.opportunity__c = opportunity.sfid)')
                .innerJoin(service_view_1.ServiceView, 'service', '(job_service.Service__c = service.sfid AND service.opportunity__c = opportunity.sfid)')
                .where('job_service.is_active__c = TRUE');
            const columnsIterator = new entity_1.EntityColumnIterator({
                id: true,
                sfid: true,
                invoicing_target__c: true,
                sfj_job_sfid: true,
            });
            columnsIterator.all(baseJobServiceColumns, (columnName) => {
                qb.addSelect(`job_service.${columnName}`, columnName);
            });
            columnsIterator.all(serviceColumns, (columnName) => {
                qb.addSelect(`service.${columnName}`, columnName);
            });
            const viewVersion = (0, entity_1.getViewVersion)(qb, [], connection);
            qb.comment(`-- DDL checksum : ${viewVersion.hash}`);
            return qb;
        },
    })
], ServiceForJobView);
exports.ServiceForJobView = ServiceForJobView;
//# sourceMappingURL=service-for-job-view.js.map